export default __webpack_public_path__ + "static/media/grillochfotboll.8b5834e3.jpeg";